import { getCurrentTradeDate } from '@/helpers/dateHelper';
import useLanguage from '@/utils/hooks/useLanguage';
import { useDateFormatter } from '@react-aria/i18n';
import { useMemo } from 'react';

interface CurrentTradeDateProps {}

const CurrentTradeDate = (props: CurrentTradeDateProps) => {
    const lang = useLanguage();
    const dateFormatter = useDateFormatter({ timeZone: 'UTC' });

    const currentTradeDate = useMemo(() => {
        return dateFormatter.format(getCurrentTradeDate());
    }, [dateFormatter]);

    return (
        <span className="text-brand-neutral-500 text-xs">
            {lang.blotters.currentTradeDate}: {currentTradeDate}
        </span>
    );
};

export default CurrentTradeDate;
